/**
 * ZIP file builder using fflate for compression.
 * Creates downloadable ZIP archives for bulk conversion results.
 */

import { zipSync, strToU8 } from 'fflate';

export interface ZipFile {
  /** Filename inside the ZIP */
  name: string;
  /** File content */
  content: string;
}

/**
 * Create a ZIP file from multiple file contents.
 * 
 * @param files - Array of files to include in the ZIP
 * @returns Blob containing the ZIP file
 */
export function createZip(files: ZipFile[]): Blob {
  // Build the file map for fflate
  const fileMap: Record<string, Uint8Array> = {};
  
  for (const file of files) {
    // Convert string content to Uint8Array
    fileMap[file.name] = strToU8(file.content);
  }
  
  // Create the ZIP with compression
  const zipData = zipSync(fileMap, {
    level: 6, // Balanced compression level
  });
  
  // Copy into a fresh buffer to avoid SharedArrayBuffer types
  const zipBytes = new Uint8Array(zipData.byteLength);
  zipBytes.set(zipData);

  return new Blob([zipBytes], { type: 'application/zip' });
}

/**
 * Generate a ZIP filename based on timestamp.
 */
export function generateZipFilename(prefix = 'converted-profiles'): string {
  const timestamp = new Date().toISOString().slice(0, 19).replace(/[:-]/g, '');
  return `${prefix}-${timestamp}.zip`;
}

export default { createZip, generateZipFilename };
